import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth.jsx'

/**
 * Auth guard. Renders children only for an authenticated session; otherwise
 * redirects to /login, preserving the attempted location so we can return
 * the user there after they sign in.
 */
export default function ProtectedRoute({ children }) {
  const { isAuthed, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) return null // App-level splash handles the loading state.

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return children
}
